import request from "@/utils/request.js";

/**
 * 模糊查询医院科室列表
 * @param params
 * @returns {AxiosPromise}
 */
export function listHospitalDepartment(params) {
  return request({
    url: "/activityService/api/app/spring/ext/listHospitalDepartment",
    method: "post",
    data: params
  });
}

/**
 * 获取用户（护士）信息
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserNurseApp(params) {
  return request({
    url: "/userService/api/app/userNurse/getUserNurseApp",
    method: "post",
    data: params
  });
}

/**
 * 更新护士信息
 * @param params
 * @returns {AxiosPromise}
 */
export function updateUserNurseApp(params) {
  return request({
    url: "/userService/api/app/userNurse/updateUserNurseApp",
    method: "post",
    data: params
  });
}

/**
 * 查询医院
 * @param params
 * @returns {AxiosPromise}
 */
export function listHospital(params) {
  return request({
    closeLoading: true,
    url: "/operateService/api/baseHospitalDictionary/listHospital",
    method: "post",
    data: params
  });
}

/**
 * 新增医院
 * @param params
 * @returns {AxiosPromise}
 */
export function saveHospital(params) {
  return request({
    closeLoading: true,
    url: "/operateService/api/baseHospitalDictionary/saveHospital",
    method: "post",
    data: params
  });
}

/**
 * 获取用户工号
 * @param params
 * @returns {AxiosPromise}
 */
export function getOrgUserVO(params) {
  return request({
    closeLoading: true,
    url: "/teachingPlatformService/api/app/orgUser/getOrgUserVO",
    method: "post",
    data: params
  });
}
/**
 * 修改机构员工工号
 * @param params
 * @returns {AxiosPromise}
 */
export function modifyOrgUser(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/modifyOrgUser",
    method: "post",
    data: params //注意：如果是get请求请使用 params: params
  });
}
